/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Router from "./Router.container";

export default Router;
